import React, { useState, useEffect } from 'react';
import moment from 'moment';

import ProgressBar from 'components/ProgressBar/progressBar';
import { RectangleButton } from 'components/Button/rectangleButton';
import { MidContainer, ProgressRowContainer, ProgressBarAndTimeContainer, ProgressTime } from './styles';

export default function FreecodeProgressBar({ ticket, submit }) {
  const [timeLeft, setTimeLeft] = useState(ticket.timeLimit);
  const [timeLeftUnit, setTimeLeftUnit] = useState(undefined);
  const [percent, setPercent] = useState(0);
  const [hideProgress, setHideProgress] = useState(false);

  useEffect(() => {
    const updateTimeLeft = () => {
      let newTimeLeft = moment(ticket.deadlineAt).diff(Date.now(), 'seconds');
      let newTimeLeftUnit = 'seconds';

      let secondsPassed = moment(Date.now()).diff(ticket.startedAt, 'seconds');
      setPercent((100 * secondsPassed) / (secondsPassed + newTimeLeft));

      if (newTimeLeft > 60) {
        newTimeLeft = moment(ticket.deadlineAt).add(1, 'minutes').diff(Date.now(), 'minutes');
        newTimeLeftUnit = 'minutes';
      }

      // Update timeLeft with a function to access the old value
      const setTimeLeftHelper = (oldTimeLeft) => {
        if (newTimeLeftUnit === 'minutes' && oldTimeLeft === 5 && newTimeLeft < oldTimeLeft) setHideProgress(false);
        return newTimeLeft;
      };

      setTimeLeft(setTimeLeftHelper);
      setTimeLeftUnit(newTimeLeftUnit);

      if (newTimeLeft <= 0) {
        clearInterval(timeLeftInterval);
        submit();
      }
    };

    updateTimeLeft();
    const timeLeftInterval = setInterval(updateTimeLeft, 1000);
    return () => {
      clearInterval(timeLeftInterval);
    };
  }, [submit, ticket.deadlineAt, ticket.startedAt]);

  const toggleHide = () => setHideProgress(!hideProgress);

  return (
    <MidContainer>
      <ProgressRowContainer>
        {!hideProgress && (
          <ProgressBarAndTimeContainer>
            <ProgressBar percent={percent} barType="track" />
            <ProgressTime>{timeLeftUnit ? `${timeLeft} ${timeLeftUnit} remaining` : 'Calculating..'}</ProgressTime>
          </ProgressBarAndTimeContainer>
        )}
        <RectangleButton small onClick={toggleHide}>
          {hideProgress ? 'Display Time' : 'Hide Time'}
        </RectangleButton>
      </ProgressRowContainer>
    </MidContainer>
  );
}
